module.exports = __webpack_public_path__ + "img/sheep.be5030ca.webp";